<template>
  <div class="header" v-if="channelData">
    <!-- <van-tabs  color="#008AFF" class="tab-warpper" line-width="8%" @click="channelClick">
      <van-tab class="hhh" :class="{ kindClass:item.dataSalechnlCode===channelNum}" v-for="(item,index) of channelData" :key="index" :title="item.salechnlName" :channelData="channelData"></van-tab>
    </van-tabs> -->
    <van-row class="headerKind" type="flex" justify="space-around">
      <van-col
        v-for="(item,index) of channelData" :key="index"
        :class="{ kindClass:item.dataSalechnlCode===channelNum}">
        <span @click="channelClick(item)" :channelData="channelData">
          {{item.salechnlName}}
        </span>
      </van-col>
    </van-row>
  </div>
</template>

<script>
// import { postAction } from '@/utils/api'
// import { getUrlKey } from '@/utils/util'
export default {
  name: 'Header',
  data () {
    return {
      channelData: [],
      getUrl: '',
      getUrl1: '',
      channelNum: null
    }
  },
  methods: {
    getHomeInfo () {
      this.channelData = [{ dataSalechnlCode: '0101', salechnlName: '整体' }]
      this.channelNum = this.channelData[0].dataSalechnlCode
      // var postData
      // var url = '/simpapp/performance/getYeJiIndexCard'
      // this.getUrl = getUrlKey('indexId', window.location.href)
      // this.getUrl1 = getUrlKey('businessId', window.location.href)
      // if (this.getUrl && this.getUrl1) {
      //   postData = {
      //     'indexCode': this.getUrl,
      //     'pageCode': this.getUrl1,
      //     'date': this.date || '' // 传入时间
      //   }
      // } else {
      // postData = {
      //     'indexCode': this.$store.state.entirety.quota,
      //     'pageCode': this.$store.state.entirety.kind,
      //     'date': this.date || '' // 传入时间
      // }
      // }
      // var obj = postAction(url, postData)
      // let self = this
      // obj.then(res => {
      //   self.channelData = res.data.salechnl
      //   self.$store.commit('ENTIRETY_SET_CHANNEL', self.channelData[0].dataSalechnlCode)
      //   self.$store.commit('ENTIRETY_SET_CHANNEL_NAME', self.channelData[0].salechnlName)
      //   var channelQuota = []
      //   self.$store.commit('ENTIRETY_SET_CHANNEL_QUOTA', channelQuota)
      //   channelQuota.push(self.channelData[0].dataSalechnlCode)
      //   channelQuota.push(self.$store.state.entirety.quota)
      //   self.$store.commit('ENTIRETY_SET_CHANNEL_QUOTA', channelQuota)
      //   self.channelNum = self.channelData[0].dataSalechnlCode
      // })
    },
    channelClick (data) {
    //   this.channelNum = data.dataSalechnlCode
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.getHomeInfo() // 进入详情页面调取方法
  }
}
</script>

<style lang="stylus" scoped>
  .header>>>.van-tab span{
    font-size : .16rem;
    line-height : 3;
    font-weight : 400;
    color : #999;
    // font-family:SFUIText-Medium;
  }
  .header>>>.van-tab--active span{
    color : #008AFF
  }
  .header>>>.van-tabs__nav--line{
    padding-bottom : 0rem;
  }
  .header>>>.van-tabs__line{
    bottom : 0;
    border-radius:100px 100px 0px 0px;
  }
  .header>>>.van-tabs--line .van-tabs__wrap{
    height : auto;
  }
  .header{
    min-height .48rem
    background #fff
    display : flex;
    width : 100%;
  }
  .tab-warpper{
    width : 100%;
  }
  .tab-warpper .nav-title{
    font-size : 5rem;
    color : red;
  }
  >>>.van-tabs__wrap--scrollable .van-tab{
    flex-basis: 20% !important
  }
  .kindClass {
    position relative
    color #3399FF
    display flex
    justify-content center
  }
  // .kindClass:after {
  //   content: '';
  //   width: 30px;
  //   height: 3px;
  //   background: #008aff;
  //   display: block;
  //   position: absolute;
  //   bottom: 0;
  //   border-radius: 10px 10px 0 0;
  // }
.headerKind {
  width: 100%;
  background: #fff;
  font-size: 0.16rem;
  text-align: center;
  line-height: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/operate/components/OperateDetailHeader.vue